import { GET_USER_STATE_SUCCESS } from 'actions/userStateActions';
import get from 'lodash/get';

export default function abExperiments(state = {}, action) {
	switch (action.type) {
		case GET_USER_STATE_SUCCESS:
			const experiments = get(action, ['data', 'RESPONSE', 'abResponse', 'abExperiments']) || [];
			return experiments
				.filter(
					exp =>
						exp &&
						(exp.appId === 'Desktop' || exp.appId === 'sherlock' || exp.appId === 'Mapi' || exp.appId === 'Checkout')
				)
				.reduce((p, exp) => {
					const abKeys = Object.keys(exp.metadata);
					const abValue = abKeys.reduce((aggregate, key) => {
						let mutatedValue = {};
						mutatedValue[key] = {
							value: exp.metadata[key],
							abId: exp.abId,
							expId: exp.expId
						};
						return Object.assign(aggregate, mutatedValue, {});
					}, {});
					return Object.assign(p, abValue, {});
				}, {});
		default:
			return state;
	}
}
